<div class="row">
    <div class="col-12">
        <div class="blocks m-3 pt-0 px-0">
            <form [formGroup]="formBuilder">
                <!--main input disabled-->
                <div class="row px-3">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="m-3">
                            <i class="far fa-tools fa-lg mr-5"></i>
                            <label class="form-label label-fw"> Gestisci prenotazione</label>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="m-3 end">
                            <button *ngIf="isBtnVisibile" (click)="reserveButton()" type="button"
                                class="btn btn-outline-warning btn-outline-fw reserve-b text reserve-b">Completa appuntamento</button>
                        </div>
                    </div>
                </div>
                <div class="row px-3">
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Stato prenotazione</label>
                                <span class="sub-menu form-control form-fw view-i">{{appointmentStatus}}</span>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Cognome</label>
                            <span class="sub-menu form-control form-fw view-i">{{surname}}</span>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">URL della pagina</label>
                            <span class="sub-menu form-control form-fw view-i">{{pageUrl}}</span>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Tipologia</label>
                            <span class="sub-menu form-control form-fw view-i">
                                {{type}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row px-3">
                    <div class="col-12">
                        <div class="m-3 border-b"></div>
                    </div>
                </div>
                <div class="row px-3">
                    <div class="col-12">
                        <div class="m-3">
                            <i class="far fa-user fa-lg mr-5"></i>
                            <label class="form-label label-fw"> Dati personali</label>
                        </div>
                    </div>
                </div>
                <div class="row px-3">
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Nome</label>
                                <span class="sub-menu form-control form-fw view-i">{{name}}</span>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Cognome</label>
                            <span class="sub-menu form-control form-fw view-i">{{surname}}</span>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Telefono</label>
                                <span class="sub-menu form-control form-fw view-i">{{telephone}}</span>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Email</label>
                            <span class="sub-menu form-control form-fw view-i">{{email}}</span>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Cliente fastweb</label>
                            <span class="sub-menu form-control form-fw view-i">{{isFastwebCustomer}}</span>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Codice fiscale</label>
                            <span class="sub-menu form-control form-fw view-i">{{fiscalcode}}</span>
                        </div>
                    </div>
                    <div class="col-3">

                    </div>
                    <div class="col-3">

                    </div>
                </div>
                <div class="row px-3">
                    <div class="col-12">
                        <div class="m-3 border-b"></div>
                    </div>
                </div>
                <div class="row px-3">
                    <div class="col-12">
                        <div class="m-3">
                            <i class="far fa-info-circle fa-lg mr-5"></i>
                            <label class="form-label label-fw"> Dettaglio</label>
                        </div>
                    </div>
                </div>
                <div class="row px-3">
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Codice prenotazione</label>
                            <span class="sub-menu form-control form-fw view-i">{{appointmentCode}}</span>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Store di riferimento </label>
                            <span class="sub-menu form-control form-fw view-i">{{storeCity}}</span>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Indirizzo Store</label>
                            <span class="sub-menu form-control form-fw view-i">{{storeAddress}}</span>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Data prenotazione</label>
                            <span class="sub-menu form-control form-fw view-i">{{appointmentDate}}</span>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12">
                        <div class="m-3">
                            <label class="form-label label-fw">Data appuntamento</label>
                            <span class="sub-menu form-control form-fw view-i">{{reservationDate}}</span>
                        </div>
                    </div>

                    <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12" *ngIf="(flgConsentCommMktgLead != null)">
                        <div class="m-3">
                            <label class="form-label label-fw">Flag consenso</label>
                            <span *ngIf="flgConsentCommMktgLead" class="sub-menu form-control form-fw view-i">Attivo</span>
                            <span *ngIf="!flgConsentCommMktgLead" class="sub-menu form-control form-fw view-i">Non attivo</span>
                        </div>
                    </div>

                </div>
            </form>
            <!--Buttons-->
            <div class="row">
                <div class="col-12">
                    <div class="my-4 text-center">
                        <button (click)="clickButtonCancel()" type="button"
                            class="btn btn-outline-warning btn-outline-fw text">Indietro</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>